export default __webpack_public_path__ + "static/media/MUSEU_negativo.b414941e.png";